module.exports = __webpack_public_path__ + "static/media/logo-header.4d49d838.svg";